export default __webpack_public_path__ + "static/media/inspectionVisits.708c52dd.png";